import { StyleSheet } from 'react-native';
import { colors } from '../../utils/colors';

export const styles = StyleSheet.create({
	genreBar__container: {
		marginLeft: 10,
		marginBottom: 25,
		marginTop: 20,
	},
	genreBar: {
		fontSize: 20,
		display: 'flex',
		flexDirection: 'row',
	},
	genreBar__genre: {
		borderColor: colors.spotifyGreen,
		borderWidth: 2,
		textTransform: 'uppercase',
		padding: 8,
		display: 'flex',
		justifyContent: 'center',
		borderRadius: 16,
		margin: 2,
		padding: 8,
	},
	genreBar__genre__pressed: {
		// borderColor: colors.spotifyGreen,
		// borderWidth: 2,
		textTransform: 'uppercase',
		display: 'flex',
		justifyContent: 'center',
		borderRadius: 16,
		margin: 2,
		padding: 10,
		backgroundColor: colors.spotifyGreen,
	},
	genreBar__genre__text: {
		textTransform: 'uppercase',
		color: colors.spotifyGreen,
		fontSize: 12,
	},
	genreBar__genre__text__pressed: {
		color: colors.white,
	},
	genreBar__genrexxyellow: {
		borderColor: colors.yellow,
	},
	genreBar__genre__textxxyellow: {
		color: colors.yellow,
	},
	// event__singleGenre: {
	// 	// paddingLeft: 8,
	// 	// paddingRight: 8,
	// 	// paddingTop: 6,
	// 	// paddingBottom: 6,
	// 	display: 'flex',
	// 	padding: 8,
	// 	color: colors.white,
	// 	fontFamily: 'Lato_400Regular',
	// 	textTransform: 'uppercase',
	// 	fontSize: 9,
	// 	borderWidth: 2,
	// 	borderRadius: 12,
	// 	margin: 2,
	// 	// display: 'flex',
	// 	flexDirection: 'row',
	// 	// justifyContent: 'center',
	// 	// alignItems: 'center',
	// 	textAlign: 'center',
	// },
	// event__singleGenre__container: {
	// 	// display: 'flex',
	// 	// justifyContent: 'center',
	// 	// alignItems: 'center',
	// 	display: 'flex',
	// 	justifyContent: 'center',
	// 	borderWidth: 2,
	// 	// borderColor: colors.purple,
	// 	borderRadius: 12,
	// 	margin: 2,
	// 	padding: 8,
	// },
	// event__singleGenre__text: {
	// 	color: colors.white,
	// 	fontFamily: 'Lato_400Regular',
	// 	textTransform: 'uppercase',
	// 	fontSize: 9,
	// 	padding: 0,
	// 	margin: 0,
	// 	includeFontPadding: false,
	// },

	// event__singleGenre__yellow: {
	// 	borderColor: colors.yellow,
	// 	color: colors.yellow,
	// },
	// event__singleGenre__green: {
	// 	borderColor: colors.green,
	// 	color: colors.green,
	// },
	// event__singleGenre__purple: {
	// 	borderColor: colors.purple,
	// 	color: colors.purple,
	// },
});
